<template>
<div v-if="isShow">
    <div v-if="!isResetPhone">
        <header>電話番号認証
        </header>
        <div id="wrap">
            <div class="txt-area">
                <p>最後に、あなたがロボットや業者でないことを証明するために6桁の認証コードを入力してください。</p>
            </div>
            <div class="cp_iptxt">
                <input maxlength="6" type="text" name="verify_code" placeholder="認証コード（6桁の数字）" v-model="formData.verify_code" @change="setLimitCode" autocomplete="off">
                <i class="fas fa-lock fa-lg fa-fw" aria-hidden="true"></i>
            </div>
            <p class="login-4">ご入力いただいた番号（090-0000-0000）宛てにSMSにて、認証コードを送信いたしました。<br>
                受信いただいた6桁の数字が認証コードとなりますので、ご確認のうえ入力してください。</p>
            <p class="login-5"><a @click="getSMSCode">認証コードを再送する</a></p>
            <p class="login-5"><a @click="resetPhone">電話番号を再入力</a></p>
            <div :class="setLimitCode() ? 'btn1' : 'btn3'" id="btn_verify_sms_code"><a @click="verifySMSCode()">次へ</a></div>
        </div>
    </div>
    <resetPhone @close="isResetPhone = false" :dataPhone="dataPhone" :isShow="isResetPhone" @submit="submitResetPhone"></resetPhone>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from "vuex";
import CONSTANTS from '@/constants'
import resetPhone  from "./resetPhone"
import {
    setVerifyPhone,
    getToken
} from '@/auth'
export default {
    props: {
        isShow: Boolean,
        dataPhone: String
    },
    emits: ['close'],
    components: {
        resetPhone
    },
    data: () => ({
        formData: {
            verify_code: null
        },
        isResetPhone: false
    }),
    mounted() {

    },
    computed: {
        ...mapGetters(["metadata", "userDetail"]),
    },
    watch: {
        isResetPhone() {
            window.scrollTo(0, 0)
        }
    },
    methods: {
        ...mapActions({
            userProfile: 'user/userProfile'
        }),
        checkAuthCode() {
            if (this.formData.verify_code && this.formData.verify_code.length === 6) {
                return true
            } else false
        },
        setLimitCode() {
            if (this.formData.verify_code && this.formData.verify_code.length > 6) {
                this.formData.verify_code = this.formData.verify_code.substr(0, 6)
            } 
            if (this.formData.verify_code && this.formData.verify_code.length === 6) {
                return true
            } else false
        },
        async getSMSCode() {
            this.$store.dispatch("route/showLoading")
            await this.$store.dispatch('register/getSMSCode', {
                phone_number: this.dataPhone,
                token: getToken()
            }).catch(err => {
                console.log(err)
            })
            this.$store.dispatch("route/hideLoading")
        },
        resetPhone() {
            this.isResetPhone = true
        },
        async verifySMSCode() {
            if (!this.checkAuthCode()) {
                return
            }
            this.$store.dispatch("route/showLoading")

            await this.$store.dispatch('register/verifySMSCode', {
                verify_code: this.formData.verify_code,
                token: getToken()
            }).then(async data => {
                await this.userProfile({
                    token: getToken()
                })
                if (this.userDetail && parseInt(this.userDetail.is_verify_phone) === CONSTANTS.VERIFY_PHONE_NUMBER_SUCCESS) {
                    setVerifyPhone()
                    this.$emit('close')
                } else {
                    alert('Verify phone number fail')
                }
            }).catch(err => {
                alert(err.response.data.message)
                console.log(err)
            })
            this.$store.dispatch("route/hideLoading")
        },
        submitResetPhone(phone) {
            this.isResetPhone = false
            this.$emit('changePhone', phone)
        }
    }
}
</script>
